var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHumanNhiInstances = function SvgHumanNhiInstances(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "m12.833 14.333 1.667-1.666L12.833 11m-2.666 0L8.5 12.667l1.667 1.666M2.667 14c0-.93 0-1.396.115-1.774a2.67 2.67 0 0 1 1.778-1.778c.378-.115.843-.115 1.774-.115H7M11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0"
  })));
};
export default SvgHumanNhiInstances;